import CopyrightInput from '@/components/common/CopyrightInput';
import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import { buildCopyrightLine } from '@/components/common/ProductUtilities';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrackEditViewTemplateProps } from '../TrackEditViewTemplate';
import { BaseFormGroupProps } from './types';

type Props = Pick<
  TrackEditViewTemplateProps,
  | 'trackData'
  | 'baseMixedTrack'
  | 'handleInput'
  | 'fieldHasErrors'
  | 'fieldValidationState'
  | 'findErrorMessage'
  | 'isMultipleTrack'
  | 'areNewMultipleTracks'
> &
  BaseFormGroupProps;

export default function TrackCopyrightYearFormGroup({
  trackData,
  baseMixedTrack,
  readonly,
  disabled,
  handleInput,
  fieldHasErrors,
  fieldValidationState,
  findErrorMessage,
  isMultipleTrack,
  areNewMultipleTracks,
}: Props) {
  const { t } = useTranslation();

  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.track.cLine"
      hasErrors={
        (!isMultipleTrack && fieldHasErrors('CopyrightYear')) ||
        (!isMultipleTrack && fieldHasErrors('CopyrightLine'))
      }
    >
      <CopyrightInput
        id={'trackCopyrightYear'}
        labelText={t('product.editProduct.cline')}
        year={
          !isMultipleTrack
            ? trackData.copyrightYear
            : (baseMixedTrack?.copyrightYear?.value as number)
        }
        originalYear={baseMixedTrack?.copyrightYear?.originalValue as number}
        onYearChange={(year) => handleInput('copyrightYear', year)}
        linePlaceholderLabelText={t('product.editProduct.copyright_owner')}
        line={
          !isMultipleTrack
            ? trackData.copyrightLine
            : (baseMixedTrack?.copyrightLine?.value as string)
        }
        originalLine={baseMixedTrack?.copyrightLine}
        onLineChange={(line) => handleInput('copyrightLine', line)}
        yearErrorMessage={
          fieldHasErrors('CopyrightYear') && !isMultipleTrack
            ? findErrorMessage('CopyrightYear')
            : undefined
        }
        yearValidationState={
          !isMultipleTrack ? fieldValidationState?.('CopyrightYear') : undefined
        }
        lineErrorMessage={
          fieldHasErrors('CopyrightLine') && !isMultipleTrack
            ? findErrorMessage('CopyrightLine')
            : undefined
        }
        lineValidationState={
          !isMultipleTrack ? fieldValidationState?.('CopyrightLine') : undefined
        }
        displayLineBuilder={buildCopyrightLine}
        readonly={readonly}
        disabled={disabled}
        labelClassName="col-sm-3 form-label"
        inputPairClassName="col-sm-6 pair-input-container padding-left-0"
        errorMessageClassName="col-sm-2 popUp-container"
        multiTrack={isMultipleTrack}
        showChangeIndicator={!areNewMultipleTracks}
      />
    </FormGroupWithTooltip>
  );
}
